export { default as configManager } from './configManager';

export {
    SESSION_TYPE_ALIAS,
    SESSION_TYPES,
    SESSION_TYPE_NAMES,
    SESSION_TYPE_COLOR,
    SESSION_TYPE_ICONFONT_NAME,
    KEYWORD_COLORS,
    defaultPageInfo0,
    defaultPageInfo,
    DomType2SectionTypeMap,
    NO_PERMISSION,
    homeworkTypeNameMap,
    PLAN_VERSION_TYPE,
    Live,
} from './@constant';
